// Block Types - matching Flutter BlockTypes exactly (PascalCase)
// eslint-disable-next-line no-unused-vars
export enum BlockTypes {
  // eslint-disable-next-line no-unused-vars
  BANNER = 'Banner',
  // eslint-disable-next-line no-unused-vars
  SEARCH_BAR = 'SearchBar',
  // eslint-disable-next-line no-unused-vars
  STICKERS = 'Stickers',
  // eslint-disable-next-line no-unused-vars
  ORGANIZATIONS = 'Organizations',
  // eslint-disable-next-line no-unused-vars
  RICH_TEXT = 'RichText',
  // eslint-disable-next-line no-unused-vars
  ANNOUNCEMENT = 'Announcement',
  // eslint-disable-next-line no-unused-vars
  QUESTION = 'Question',
  // eslint-disable-next-line no-unused-vars
  COLLECTIONS = 'Collections',
  // eslint-disable-next-line no-unused-vars
  LIST = 'List',
}

// Search Types (matching Flutter's StaticSearchType enum)
// eslint-disable-next-line no-unused-vars
export enum SearchType {
  // eslint-disable-next-line no-unused-vars
  NON_PROFITS = 'non-profits',
  // eslint-disable-next-line no-unused-vars
  ORGANIZATIONS = 'organizations',
  // eslint-disable-next-line no-unused-vars
  USERS = 'users',
  // eslint-disable-next-line no-unused-vars
  STICKERS = 'stickers',
}

// Base Block Interface
export interface BaseBlock {
  id: string;
  sortOrder: number;
  blockType: BlockTypes;
}

// Banner Block
export interface BannerItem {
  imageUrl: string;
  deepLink: string;
}

export interface BannerBlock extends BaseBlock {
  blockType: BlockTypes.BANNER;
  title?: string;
  setFullWidth: boolean;
  items: BannerItem[];
}

// Search Bar Block
export interface SearchBarBlock extends BaseBlock {
  blockType: BlockTypes.SEARCH_BAR;
  searchType: SearchType;
  placeholderText: string;
}

// Stickers Block - stores actual sticker data (matching Flutter)
export interface StickersBlock extends BaseBlock {
  blockType: BlockTypes.STICKERS;
  title: string;
  columnsCount: number;
  stickers: any[]; // Actual sticker data populated from stickersList
}

// Organizations Block - stores actual organization data (matching Flutter)
export interface OrganizationsBlock extends BaseBlock {
  blockType: BlockTypes.ORGANIZATIONS;
  title: string;
  organizations: any[]; // Actual organization data populated from organizationsList
}

// Rich Text Block
export interface RichTextBlock extends BaseBlock {
  blockType: BlockTypes.RICH_TEXT;
  heading: string;
  text: string;
}

// Announcement Block
export interface AnnouncementBlock extends BaseBlock {
  blockType: BlockTypes.ANNOUNCEMENT;
  text: string;
  textColor: string;
  textBackgroundColor: string;
}

// Question Block
export interface QuestionBlock extends BaseBlock {
  blockType: BlockTypes.QUESTION;
  text: string;
  questionId: string;
  organization: any | null; // Populated organization data (matching Flutter)
}

// Collections Block
export interface CollectionGroup {
  title: string;
  coverImageUrl: string;
  organizations: any[]; // Actual organization data (matching Flutter)
}

export interface CollectionsBlock extends BaseBlock {
  blockType: BlockTypes.COLLECTIONS;
  title: string;
  groups: CollectionGroup[];
}

// List Block - stores actual organization data (matching Flutter)
export interface ListBlock extends BaseBlock {
  blockType: BlockTypes.LIST;
  title: string;
  organizations: any[]; // Actual organization data populated from organizationsList
}

// Union type for all blocks
export type Block =
  | BannerBlock
  | SearchBarBlock
  | StickersBlock
  | OrganizationsBlock
  | RichTextBlock
  | AnnouncementBlock
  | QuestionBlock
  | CollectionsBlock
  | ListBlock;

// Static Page
export interface StaticPageData {
  id: string;
  slug: string;
  title: string;
  greenGradientEnabled: boolean;
  blocks: Block[];
  organizations?: any[];
  stickers?: any[];
}
